module.exports = __webpack_public_path__ + "static/media/accessible.4179311c.svg";